// extracted by mini-css-extract-plugin
export default {"caption":"LopListContainer_caption__J37Sc","container":"LopListContainer_container__2NeMv","actions":"LopListContainer_actions__JY7Ms","space":"LopListContainer_space__pRU6c"};